import { makeImmutable } from "../core";
export class PPhoto {
    constructor(url, alt) {
        this.url = url;
        this.alt = alt;
        makeImmutable(this);
    }
}
